import { render, staticRenderFns } from "./cancellation-feedback.vue?vue&type=template&id=bc155ab4&scoped=true"
import script from "./cancellation-feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./cancellation-feedback.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cancellation-feedback.vue?vue&type=style&index=0&id=bc155ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc155ab4",
  null
  
)

export default component.exports